<template>
  <b-card no-body>
    <b-card-body>
      <address-book-detail
        ref="warehouseDetail"
        type="edit"
        :submitting="submitting"
        :values="data"
        @submit="submit"
      />
    </b-card-body>
  </b-card>
</template>

<script>
import { useUtils as useI18nUtils } from '@core/libs/i18n';
import { BCard, BCardBody } from 'bootstrap-vue';
import { helper } from '@core/mixins/helper';
import useService from '@/auth/service/useService';
import AddressBookDetail from '@/views/pages/address-book/AddressBookDetail.vue';

export default {
  components: {
    BCard,
    BCardBody,
    AddressBookDetail
  },
  mixins: [helper],
  data() {
    return {
      submitting: false,
      id: '',
      data: {}
    };
  },
  created() {
    const { id } = this.$route.params;
    this.id = id;
    this.getWarehouseData(id);
  },
  methods: {
    submit(data) {
      this.submitting = true;
      useService
        .editWarehouse(this.id, {
          ...data,
          status: data.status ? 1 : 0
        })
        .then(response => {
          if (response.status) {
            this.showSuccessMessage(`${response.message}`);
            this.$router.push('/address_book');
          }
        })
        .catch(messages => {
          if (typeof messages === 'object' && messages && messages.length) {
            messages.forEach(item => {
              this.showErrorMessage(item.message);
            });
          }
        })
        .finally(() => {
          this.submitting = false;
        });
    },
    getWarehouseData(id) {
      this.submitting = true;
      useService
        .getWarehouse(id)
        .then(response => {
          this.data = response.data;

          const { name, type, email, country, state, city, address } = response.data;

          this.data = {
            name,
            address,
            type,
            attention_name: response.data.attentionName,
            phone_number: response.data.phoneNumber,
            postal_code_id: this.getPostalCodeRequest(response.data.postalCode),
            email,
            status: response.data.status === 1,
            country_id: this.getDistrictRequest(country),
            state_id: this.getDistrictRequest(state),
            city_id: this.getDistrictRequest(city)
          };
        })
        .catch(messages => {
          if (typeof messages === 'object' && messages && messages.length) {
            messages.forEach(item => {
              this.showErrorMessage(item.message);
            });
          }
        })
        .finally(() => {
          this.submitting = false;
        });
    }
  },
  setup() {
    const { t } = useI18nUtils();

    return {
      t
    };
  }
};
</script>
